export default {
  "mainVegetable": "verdure",
  "mainVegetable/01": "verdure/melanzane",
  "mainVegetable/02": "verdure/asparagi",
  "mainVegetable/03": "verdure/avocado",
  "mainVegetable/04": "verdure/barbabietole",
  "mainVegetable/05": "verdure/broccoli",
  "mainVegetable/06": "verdure/carote",
  "mainVegetable/07": "verdure/sedano",
  "mainVegetable/08": "verdure/funghi-champignon",
  "mainVegetable/09": "verdure/cavolo",
  "mainVegetable/10": "verdure/cavoletti-di-bruxelles",
  "mainVegetable/11": "verdure/cavolo-cinese",
  "mainVegetable/12": "verdure/cavolfiore",
  "mainVegetable/13": "verdure/insalata-di-cavolo",
  "mainVegetable/14": "verdure/cetrioli",
  "mainVegetable/15": "verdure/zucchine",
  "mainVegetable/16": "verdure/indivia",
  "mainVegetable/17": "verdure/spinaci",
  "mainVegetable/18": "verdure/fave",
  "mainVegetable/19": "verdure/fagiolotti-verdi",
  "mainVegetable/20": "verdure/taccole",
  "mainVegetable/21": "verdure/fagioli-secchi",
  "mainVegetable/22": "verdure/fagiolini",
  "mainVegetable/23": "verdure/lenticchie",
  "mainVegetable/24": "verdure/mix-di-verdure",
  "mainVegetable/25": "verdure/mais",
  "mainVegetable/26": "verdure/misticanza",
  "mainVegetable/27": "verdure/rape",
  "mainVegetable/28": "verdure/cipolle",
  "mainVegetable/29": "verdure/soia",
  "mainVegetable/30": "verdure/peperoni",
  "mainVegetable/31": "verdure/patate",
  "mainVegetable/32": "verdure/germogli-di-soia",
  "mainVegetable/33": "verdure/radici",
  "mainVegetable/34": "verdure/lattuga",
  "mainVegetable/35": "verdure/indivia-riccia",
  "mainVegetable/36": "verdure/lattuga-iceberg",
  "mainVegetable/37": "verdure/insalata-piemontese",
  "mainVegetable/38": "verdure/riso",
  "mainVegetable/39": "verdure/lattuga-romana",
  "mainVegetable/40": "verdure/germogli-verdi",
  "mainVegetable/41": "verdure/lattuga",
  "mainVegetable/42": "verdure/songino",
  "mainVegetable/43": "verdure/rucola",
  "mainVegetable/44": "verdure/scorzobianca",
  "mainVegetable/45": "verdure/tabule",
  "mainVegetable/46": "verdure/pomodori",
  "mainVegetable/47": "verdure/fagioli-cannellini",
  "mainVegetable/48": "verdure/ceci",
  "mainVegetable/49": "verdure/porri",
  "mainVegetable/50": "verdure/zucca",
  "mainVegetable/51": "verdure/fagioli-rossi",
  "mainVegetable/52": "verdure/mele",
  "mainVegetable/53": "verdure/castagne",
  "mainVegetable/54": "verdure/prugne",
  "mainVegetable/55": "verdure/giardiniera",
  "mainVegetable/56": "verdure/olive-nere",
  "mainVegetable/57": "verdure/carciofi",
  "mainVegetable/58": "verdure/peperoni-rossi",
  "mainVegetable/59": "verdure/fagiolini-piattoni",
  "mainVegetable/60": "verdure/verdure-primavera",
  "mainVegetable/61": "verdure/ratatouille",
  "mainVegetable/62": "verdure/couscous",
  "mainVegetable/63": "verdure/tajine",
  "mainVegetable/64": "verdure/verdure-con-curry",
  "mainVegetable/65": "verdure/piselli-spezzettati",
  "mainVegetable/66": "verdure",
  "mainVegetable/67": "verdure/lenticchie-rosse",
  "mainVegetable/68": "verdure/quinoa",
  "mainVegetable/69": "verdure/farro",
  "mainVegetable/70": "verdure/bulgur",
  "mainVegetable/71": "verdure/cavolo-cappuccio-rosso",
  "mainVegetable/72": "verdure/cavolo-riccio",
  "mainVegetable/73": "verdure/cerfoglio",
  "mainVegetable/74": "verdure/cereali",
  "mainVegetable/75": "verdure/legumi",
  "mainVegetable/76": "verdure/patate-dolci",
  "mainVegetable/77": "verdure/zucca",
  "mainVegetable/78": "verdure/acetosa",
  "mainVegetable/79": "verdure/fagioli-borlotti",
  "mainVegetable/80": "verdure/piselli-e-carotine",
  "mainVegetable/81": "verdure/piselli",
  "mainVegetable/82": "verdure/edamame",
  "mainVegetable/83": "verdure/orzo",
  "mainVegetable/84": "verdure/mix-di-insalate",
  "mainVegetable/85": "verdure/pan-di-zucchero",
  "mainVegetable/86": "verdure/lattughino",
  "mainVegetable/87": "verdure/spinacino",
  "mainVegetable/88": "verdure/lollo-verde",
  "mainVegetable/89": "verdure/biete-erbette",
  "mainVegetable/90": "verdure/pastinaca",
  "mainVegetable/91": "verdure/riso-venere",
  "mainVegetable/92": "verdure",
  "mainVegetable/93": "verdure/fagioli-neri",
  "mainVegetable/94": "verdure/cavolo-cappuccio",
  "mainVegetable/95": "verdure",
  "mainVegetable/96": "verdure/pomodori-secchi",
  "mainVegetable/97": "verdure",
  "mainVegetable/98": "verdure",
  "productRange": "gamma",
  "productRange/4G_BIO": "gamma",
  "productRange/4G_SRP": "gamma",
  "productRange/BEAN_SAUCE": "gamma",
  "productRange/BEANS": "gamma",
  "productRange/BIO": "gamma/bio",
  "productRange/BON_SENGAG": "gamma/bonduelle-s-impegna",
  "productRange/BOND_KIDS": "gamma",
  "productRange/CAN_A_POEL": "gamma",
  "productRange/CAN_BIO": "gamma",
  "productRange/CAN_BOCAL": "gamma",
  "productRange/CAN_PETITS": "gamma",
  "productRange/CAN_SEC_BI": "gamma",
  "productRange/CAN_SEC_CO": "gamma",
  "productRange/CAN_SEC_CU": "gamma",
  "productRange/CAN_SEC_NA": "gamma",
  "productRange/CAN_SEC_PR": "gamma",
  "productRange/CAN_VAPEUR": "gamma",
  "productRange/CAN_VEG_SA": "gamma",
  "productRange/CAN_VEG_SR": "gamma",
  "productRange/CARTA_DELL": "gamma/carta-delle-insalate",
  "productRange/CEREAL_CAN": "gamma",
  "productRange/CEREAL_FRZ": "gamma",
  "productRange/CEREALI": "gamma/cereali-che-piacere",
  "productRange/CEREALLEGR": "gamma/cereallegre",
  "productRange/CLASSICVEG": "gamma/legumeria",
  "productRange/COCCOLE": "gamma/coccole",
  "productRange/COLDVEGE": "gamma",
  "productRange/COO_VEG": "gamma/verdure-ricettate",
  "productRange/COOKMUSH": "gamma",
  "productRange/CORN": "gamma/mais",
  "productRange/CREATIF": "gamma",
  "productRange/CROUSTIS": "gamma",
  "productRange/CRUDITES": "gamma",
  "productRange/DE_NOS_PRO": "gamma",
  "productRange/DOYMUSHACC": "gamma",
  "productRange/DOYMUSHAPE": "gamma",
  "productRange/DRYVEGE": "gamma",
  "productRange/FRANCAIS": "gamma",
  "productRange/FROZENVEGE": "gamma",
  "productRange/FRZ_ASTUCE": "gamma",
  "productRange/FRZ_FRY_MI": "gamma",
  "productRange/FRZ_GRATIN": "gamma",
  "productRange/FRZ_JUSTEA": "gamma",
  "productRange/FRZ_KELLO": "gamma",
  "productRange/FRZ_LEG_CO": "gamma",
  "productRange/FRZ_MELANG": "gamma",
  "productRange/FRZ_POELEE": "gamma",
  "productRange/FRZ_PUREES": "gamma",
  "productRange/FRZ_VEG_BI": "gamma",
  "productRange/FRZ_VEG_SR": "gamma",
  "productRange/INDFROZVEG": "gamma",
  "productRange/INSALATE_D": "gamma/insalate-degli-agricoltori",
  "productRange/INSALATONA": "gamma/insalatona-piu",
  "productRange/JEUNES_POU": "gamma",
  "productRange/LAITUES": "gamma",
  "productRange/LE_REGIONA": "gamma/le-regionali",
  "productRange/LEGUMIO": "gamma/legumio",
  "productRange/LOOP": "gamma",
  "productRange/LUNCH_BOWL": "gamma",
  "productRange/MACHE_BASE": "gamma",
  "productRange/MEL_LAITUE": "gamma",
  "productRange/MIXES_CORN": "gamma/mix-di-mais",
  "productRange/MONO_VEGE": "gamma",
  "productRange/MUSHNATEMI": "gamma",
  "productRange/MUSHNATENT": "gamma",
  "productRange/MUSHNATEPA": "gamma",
  "productRange/MUSHNATMIN": "gamma",
  "productRange/MUSHROOMS": "gamma",
  "productRange/NAT_MIX": "gamma/misti-al-naturale\n",
  "productRange/NATURA_IN": "gamma/natura-in-padella",
  "productRange/OTHER_VEG": "gamma/altre-verdure",
  "productRange/PEAS": "gamma/piselli",
  "productRange/PREPARED_VEG": "gamma",
  "productRange/RAWOCOOK": "gamma/crude-o-cotte",
  "productRange/READY_FROZ": "gamma",
  "productRange/SALABIS": "gamma/insalabis",
  "productRange/SOUPS": "gamma",
  "productRange/SPINACH": "gamma",
  "productRange/STEAM_CAN": "gamma",
  "productRange/STEAM_FRZ": "gamma",
  "productRange/STEAM_MIX": "gamma",
  "productRange/STUZZICHIA": "gamma/stuzzichiamo",
  "productRange/SUNVEGE": "gamma",
  "productRange/TOUCHE": "gamma/il-tuo-tocco",
  "productRange/TRAIT_CRUD": "gamma",
  "productRange/TRAIT_SAL": "gamma",
  "productRange/TRAIT_TABO": "gamma",
  "productRange/TUS_RECETA": "gamma",
  "productRange/VEG_TO_FRY": "gamma",
  "productRange/VEGGIE": "gamma",
  "productRange/WORLDVEGE": "gamma",
  "season": "stagioni",
  "season/1": "stagioni/estate",
  "season/2": "stagioni/autunno",
  "season/3": "stagioni/inverno",
  "season/4": "stagioni/primavera",
  "season/5": "stagioni",
  "technologie": "tecnologie",
  "technologie/AC01": "tecnologie/conserve",
  "technologie/AD01": "tecnologie/surgelati",
  "technologie/AG01": "tecnologie/fresco",
  "technologie/AT01": "tecnologie/traiteur",
  "recipeDish": "tipo-di-piatto",
  "recipeDish/ACC": "tipo-di-piatto",
  "recipeDish/APE": "tipo-di-piatto",
  "recipeDish/DES": "tipo-di-piatto",
  "recipeDish/ENT": "tipo-di-piatto",
  "recipeDish/PLAT": "tipo-di-piatto",
  "recipeDish/SAL": "tipo-di-piatto",
  "recipeDish/SNA": "tipo-di-piatto",
  "recipeDish/PDE": "tipo-di-piatto",
  "recipeDish/DEJ": "tipo-di-piatto",
  "recipeDish/TRA": "tipo-di-piatto/tradizionali",
  "recipeDish/GOU": "tipo-di-piatto/gourmet",
  "recipeDish/ETH": "tipo-di-piatto/etniche",
  "recipeDish/FCH": "tipo-di-piatto/per-bambini",
  "recipeDish/SOU": "tipo-di-piatto",
  "pred-recipeTimingCook-facet": "cottura",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "cottura/0-15-minuti",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "cottura/15-30-minuti",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "cottura/30-45-minuti",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "cottura/45-minuti",
  "pred-recipeTimingPreparation-facet": "preparazione",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "preparazione/0-15-minuti",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "preparazione/15-30-minuti",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "preparazione/30-45-minuti",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "preparazione/45-minuti",
  "pred-recipeCost-Facet": "costo",
  "pred-recipeCost-Facet/petit": "costo/basso",
  "pred-recipeCost-Facet/moyen": "costo/medio",
  "pred-recipeCost-Facet/grand": "costo/elevato",
  "recipeDifficulty": "difficolta",
  "recipeDifficulty/1": "difficolta/facili",
  "recipeDifficulty/2": "difficolta/di-media-difficolta",
  "recipeDifficulty/3": "difficolta/difficili",
  "recipeDishNumber": "porzioni",
  "recipeDishNumber/1": "porzioni/1",
  "recipeDishNumber/2": "porzioni/2",
  "recipeDishNumber/3": "porzioni/3",
  "recipeDishNumber/4": "porzioni/4",
  "recipeDishNumber/5": "porzioni/5",
  "recipeDishNumber/6": "porzioni/6",
  "recipeDishNumber/7": "porzioni/7",
  "recipeDishNumber/8": "porzioni/8",
  "productTheme": "tipologia",
  "productTheme/ACC": "tipologia",
  "productTheme/BEA": "tipologia",
  "productTheme/BIS": "tipologia",
  "productTheme/BIO": "tipologia/bio",
  "productTheme/CAN": "tipologia/conserve",
  "productTheme/CER": "tipologia",
  "productTheme/CLS": "tipologia",
  "productTheme/DLE": "tipologia",
  "productTheme/EDR": "tipologia",
  "productTheme/ENT": "tipologia",
  "productTheme/FRZ": "tipologia/surgelati",
  "productTheme/FSD": "tipologia/insalate",
  "productTheme/FSH": "tipologia",
  "productTheme/ING": "tipologia",
  "productTheme/JAR": "tipologia",
  "productTheme/LBW": "tipologia",
  "productTheme/LDF": "tipologia",
  "productTheme/LEG": "tipologia",
  "productTheme/LGO": "tipologia",
  "productTheme/LGR": "tipologia",
  "productTheme/LGS": "tipologia",
  "productTheme/MAI": "tipologia",
  "productTheme/MUS": "tipologia",
  "productTheme/NEW": "tipologia",
  "productTheme/PDH": "tipologia",
  "productTheme/PDL": "tipologia",
  "productTheme/PHR": "tipologia/pasta",
  "productTheme/PLP": "tipologia",
  "productTheme/RAL": "tipologia",
  "productTheme/RDM": "tipologia/piatti-pronti",
  "productTheme/SAL": "tipologia",
  "productTheme/SDB": "tipologia",
  "productTheme/SNK": "tipologia/pronti-per-l-aperitivo",
  "productTheme/SUP": "tipologia",
  "productTheme/TEX": "tipologia",
  "productTheme/VGP": "tipologia",
  "recipeTheme": "ricette-tipologie",
  "recipeTheme/01": "ricette-tipologie",
  "recipeTheme/02": "ricette-tipologie/antipasti-aperitivi",
  "recipeTheme/03": "ricette-tipologie/insalate-piatti-unici",
  "recipeTheme/04": "ricette-tipologie",
  "recipeTheme/05": "ricette-tipologie",
  "recipeTheme/06": "ricette-tipologie",
  "recipeTheme/07": "ricette-tipologie",
  "recipeTheme/08": "ricette-tipologie",
  "recipeTheme/09": "ricette-tipologie/contorni",
  "recipeTheme/10": "ricette-tipologie",
  "recipeTheme/11": "ricette-tipologie",
  "recipeTheme/12": "ricette-tipologie",
  "recipeTheme/13": "ricette-tipologie",
  "recipeTheme/14": "ricette-tipologie/secondi-piatti",
  "recipeTheme/15": "ricette-tipologie/dolci",
  "recipeTheme/16": "ricette-tipologie",
  "recipeTheme/17": "ricette-tipologie",
  "recipeTheme/18": "ricette-tipologie",
  "recipeTheme/19": "ricette-tipologie",
  "recipeTheme/20": "ricette-tipologie",
  "recipeTheme/21": "ricette-tipologie",
  "recipeTheme/22": "ricette-tipologie",
  "recipeTheme/23": "ricette-tipologie",
  "recipeTheme/24": "ricette-tipologie/primi-piatti",
  "recipeTheme/25": "ricette-tipologie",
  "recipeTheme/26": "ricette-tipologie",
  "recipeTheme/27": "ricette-tipologie",
  "recipeTheme/28": "ricette-tipologie",
  "recipeTheme/33": "ricette-tipologie",
  "recipeTheme/34": "ricette-tipologie",
  "recipeTheme/35": "ricette-tipologie",
  "recipeTheme/36": "ricette-tipologie",
  "recipeTheme/37": "ricette-tipologie",
  "recipeTheme/38": "ricette-tipologie",
  "recipeTheme/39": "ricette-tipologie",
  "recipeTheme/40": "ricette-tipologie",
  "recipeTheme/41": "ricette-tipologie",
  "recipeTheme/42": "ricette-tipologie",
  "recipeTheme/43": "ricette-tipologie",
  "recipeTheme/44": "ricette-tipologie",
  "recipeTheme/45": "ricette-tipologie",
  "recipeTheme/46": "ricette-tipologie",
  "pred-particularite": "abitudini-alimentari",
  "pred-particularite/Sans%20conservateur": "abitudini-alimentari/senza-conservanti",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "abitudini-alimentari",
  "pred-particularite/Sans%20colorant": "abitudini-alimentari/senza-coloranti",
  "pred-particularite/Sans%20sucre%20ajout%E9": "abitudini-alimentari/senza-zuccheri-aggiunti",
  "pred-particularite/Sans%20sel%20ajout%E9": "abitudini-alimentari/senza-sale-aggiunto",
  "pred-particularite/Sans%20additif": "abitudini-alimentari/senza-additivi",
  "pred-particularite/": "abitudini-alimentari/sale-naturalmente-presente",
  "pred-particularite/Sans%20lactose": "abitudini-alimentari/senza-lattosio",
  "pred-particularite/Sans%20gluten": "abitudini-alimentari/senza-glutine",
  "pred-particularite/V%E9g%E9tarien": "abitudini-alimentari/vegetariano",
  "pred-particularite/V%E9g%E9talien": "abitudini-alimentari/vegano",
  "pred-particularite/Sans%20sulfite": "abitudini-alimentari",
  "pred-particularite/A%20la%20vapeur": "abitudini-alimentari",
  "pred-particularite/Sans%20condiment": "abitudini-alimentari",
  "cultureType": "tipo-di-coltura",
  "cultureType/Bio": "tipo-di-coltura/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "tipo-di-coltura/senza-residui-di-pesticidi",
  "cultureType/Sans%20OGM": "tipo-di-coltura/senza-OGM",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "abitudini-alimentari/vegano",
  "pred-particularite/recipeVeggie": "abitudini-alimentari/vegetariano",
  "pred-particularite/recipeGlutenfree": "abitudini-alimentari/senza-glutine",
  "pred-particularite/recipeLactosefree": "abitudini-alimentari/senza-lattosio"
};
